export const CONTACT_EMAILS = {
  general: 'connect@tissatech.com',
  careers: 'careers@tissatech.com',
};

export const CONTACT_PHONES = {
  usa: {
    display: '+1-512-203-7627',
    tel: '+15122037627',
  },
  india: {
    display: '+91-9373772429',
    tel: '+919373772429',
  },
  australia: {
    display: '+61-490010496',
    tel: '+61490010496',
  },
};

export const OFFICE_LOCATIONS = [
  {
    country: 'USA',
    flag: 'https://flagcdn.com/w40/us.png',
    address: '2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas 77380',
    query: '2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas 77380',
    position: [30.1578, -95.4694],
    careersLines: ['2001 Timberloch Place, Suite 500', 'The Woodlands, TX 77380'],
  },
  {
    country: 'INDIA',
    flag: 'https://flagcdn.com/w40/in.png',
    address: 'Office no. 505, City Avenue, Opp. Phoenix Mall of the Millennium, Mumbai-Bangalore Highway, Wakad, Pune 411057',
    query: 'Office no. 505, City Avenue, Opp. Phoenix Mall of the Millennium, Mumbai-Bangalore Highway, Wakad, Pune 411057',
    position: [18.5913, 73.7372],
    careersLines: ['Office no. 505, City Avenue, Opp. Phoenix Mall of the Millennium', 'Mumbai-Bangalore Highway, Wakad, Pune 411057'],
  },
  {
    country: 'AUSTRALIA',
    flag: 'https://flagcdn.com/w40/au.png',
    address: '301, 1B Crandon Road, Epping NSW 2121',
    query: '301, 1B Crandon Road, Epping NSW 2121',
    position: [-33.7752, 151.0812],
    careersLines: ['301, 1B Crandon Road', 'Epping NSW 2121'],
  },
];
